import Vue from 'vue'
import VueRouter from 'vue-router'
import Games from '@/views/games'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Games',
    component: Games
  },
  {
    path: '/statetrivia/',
    name: 'StateTrivia',
    component: () => import(/* webpackChunkName: "options" */ '@/views/StateTrivia'),
  },
  {
    path: '/statetrivia/play',
    name: 'StateTriviaPlay',
    component: () => import(/* webpackChunkName: "options" */ '@/views/StateTrivia/play.vue')
  },
  {
    path: '/statetrivia/options',
    name: 'StateTriviaOptions',
    component: () => import(/* webpackChunkName: "options" */ '@/views/StateTrivia/options.vue')
  },
  {
    path: '/statetrivia/summary',
    name: 'StateTriviaSummary',
    component: () => import(/* webpackChunkName: "options" */ '@/views/StateTrivia/summary.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import(/* webpackChunkName: "about" */ '@/views/about.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
